module.exports = __webpack_public_path__ + "static/gifimg1-9ee33f8f409697c2a2abcff94bf3e5a5.gif";